// removed by extract-text-webpack-plugin
module.exports = {"contactHistory":"_3dG2cK9pahLalbcAqP6EA5","buttonContainer":"_1vXPbyaznz3EIvL2Y9P4oq","dialogBox":"_11jprE2jmPPXZCKneLta3O","blueBar":"_1d4gNHYI7-e20RoJC-d_AU","inputsContainer":"_1qSVXDgpU3oyrnFgP_6aCg","rowInputs":"bb26S_z7bSfjya66J_Ocd","contactsList":"SG56EqLRyRa6BRvoWPmR7","contactsTable":"_5tNoeMFMANyNGoM5t0lk6","tableTitles":"_5Qh07kH_V33n2SThXVWxM","tableContent":"_3m-RaGKRwzwcveP2q75ZKP"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DebtPhaseContactHistory/style.css
// module id = 1062
// module chunks = 0